import{useRef as r}from"react";var t=function(t){var e=r(void 0),n=r(void 0);return n.current!==t&&(e.current=n.current,n.current=t),e.current};export{t as default};
//# sourceMappingURL=index.js.map
